import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { scroller } from 'react-scroll'
import Expertise from 'src/components/Expertise/Expertise'
import Footer from 'src/components/Footer/Footer'
import logoutQueryString from 'src/utils/logoutQueryString'
import Navbar from 'src/components/Navbar/Navbar'

interface LocationState {
  scrollTo?: string
}

const Hero = React.lazy(
  () => import(/* webpackChunkName: "Hero" */ 'src/components/Hero/Hero')
)

const LatestNewsHome = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LatestNewsHome" */ 'src/components/LatestNewsHome/LatestNewsHome'
    )
)

const LaboratoryInfo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LaboratoryInfo" */ 'src/components/LaboratoryInfo/Laboratory'
    )
)

const Contact = React.lazy(
  () => import(/* webpackChunkName: "Contact" */ 'src/components/Contact/contact')
)

const PartnersCompanies = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PartnersCompanies" */ 'src/components/Partners/PartnerCompanies/PartnerCompanies'
    )
)

const AcademicsPartners = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AcademicsPartners" */ 'src/components/Partners/AcademicsPartners/AcademicsPartners'
    )
)

const Home = () => {
  const history = useHistory()
  const location = useLocation<LocationState>()

  useEffect(() => {
    if (location.state?.scrollTo) {
      scroller.scrollTo(location.state.scrollTo, {
        smooth: true,
        duration: 1000
      })
      history.replace('/', {})
    }
  }, [location, history])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    logoutQueryString()
  }, [])

  return (
    <>
      <React.Suspense fallback="loading..">
        <Navbar />
        <Hero />
        <LatestNewsHome />
        <LaboratoryInfo />
        <Expertise />
        <AcademicsPartners />
        <PartnersCompanies />
        <Contact />
        <Footer />
      </React.Suspense>
    </>
  )
}

export default Home
